import { Typography } from '@mui/material';
import { forwardRef } from 'react';

export default forwardRef((props, ref) => (
  <Typography
    sx={{
      fontSize: '14px',
      color: 'secondary.dark',
      width: '100%',
      p: 1,
      ...props.sx,
    }}
    align="center"
    ref={ref}
  >
    {props.status ?? 'در حال بارگذاری ...'}
  </Typography>
));
